<template>
  <div>
    <slot name="group" v-bind="{ valid, invalid: !valid, validate }" />
  </div>
</template>

<script>
export default {
  name: "InputValidateGroup",
  props: {
    scrollToError: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    validators: [],
    valid: true
  }),
  provide() {
    return {
      subscribe: item => {
        this.validators.push(item);
        this.valid = this.isValid();

        item.onChange(_ => this.onChange());

        return _ => {
          this.validators = this.validators.filter(
            validator => validator._uid !== item._uid
          );
        };
      }
    };
  },
  methods: {
    validate() {
      this.validators.forEach(validator => validator.check());

      if (this.scrollToError) {
        const invalid = this.validators.filter(validator => !validator.valid);

        if (invalid.length == 0) {
          return;
        }

        const firstInvalid = invalid.reduce(
          (pv, cv) =>
            cv.$el.getBoundingClientRect().top <
            pv.$el.getBoundingClientRect().top
              ? cv
              : pv,
          invalid[0]
        );

        setTimeout(_ => {
          firstInvalid.$el.scrollIntoView({ behavior: "smooth" });
        }, 0);
      }
    },
    isValid() {
      return (
        this.validators.filter(
          validator => document.body.contains(validator.$el) && !validator.isValid()
        ).length == 0
      );
    },
    onChange() {
      this.valid = this.isValid();
    }
  }
};
</script>
